import React from 'react'
import PropTypes from 'prop-types'

import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'
import AddressModule from 'schedule/common/modules/address/AddressModule'

import closeIcon from 'resources/close_icon.png'

const Actions = ({ onCancelClicked, onSaveClicked }) => {
  return (
    <div style={styles.actions}>
      <FlatButton
        label='Cancel'
        onTouchTap={onCancelClicked}/>
      <FlatButton
        primary={true}
        label='Save'
        onTouchTap={onSaveClicked}/>
    </div>
  )
}

Actions.propTypes = {
  onCancelClicked: PropTypes.func.isRequired,
  onSaveClicked: PropTypes.func.isRequired
}

const Header = ({ title, onCloseRequested }) => {
  return (
    <div style={styles.header}>
      <div style={styles.heading}>
        { title }
      </div>
      <div style={{ marginRight: 16 }}>
        <img src={closeIcon} title='Close' width={16}
          onClick={onCloseRequested}
          style={{ cursor: 'pointer' }} />
      </div>
    </div>
  )
}

Header.propTypes = {
  title: PropTypes.string.isRequired,
  onCloseRequested: PropTypes.func.isRequired
}

const FieldInput = ({ field, validationErrorField, value, onValueChanged }) => {
  if (field.type === 'subheader'){
    return (
      <div style={styles.inputContainer}>
        <div style={styles.subheaderDisplay}>{ field.display.toUpperCase() }</div>
      </div>
    )
  } else if (field.type === 'address'){
    return (
      <div style={styles.inputContainer}>
        <div style={styles.fieldDisplay}>{ field.display }</div>
        <AddressModule
          style={styles.fieldInput()}
          placeholder={''}
          addressValue={value}
          onUpdate={onValueChanged}/>
      </div>
    )
  } else {
    return (
      <div style={styles.inputContainer}>
        <div style={styles.fieldDisplay}>{ field.display }</div>
        <input style={styles.fieldInput(field.type === 'number' && 'right')}
          type={field.type || 'text'}
          step={field.step}
          value={value}
          onChange={event => onValueChanged(field.key, event.target.value)} />
        { validationErrorField === field.key &&
          <div style={styles.validationError}>{ `* ${field.display} is required.` }</div>
        }
      </div>
    )
  }
}

FieldInput.propTypes = {
  field: PropTypes.object.isRequired,
  validationErrorField: PropTypes.string,
  onValueChanged: PropTypes.func.isRequired
}

export default class CustomerDialog extends React.Component {

  static propTypes = {
    open: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    fields: PropTypes.array.isRequired,
    item: PropTypes.object,
    onCloseRequest: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      validationErrorField: null,
      item: {}
    }
  }

  componentWillReceiveProps(nextProps) {
    // Reset input fields when the dialog opens.
    if (nextProps.open) {
      this.setState({
        validationErrorField: null,
        item: nextProps.item || {}
      })
    }
  }

  validateInput = () => {
    for (const field of this.props.fields) {
      if (field.required && !this.state.item[field.key]) {
        return { errorField: field.key }
      }
    }
    return { success: true }
  }

  handleSaveClicked = () => {
    const validationResult = this.validateInput()
    if (!validationResult.success) {
      this.setState({
        validationErrorField: validationResult.errorField
      })
    }
    else {
      this.props.onSave(this.state.item)
    }
  }

  handleValueChanged = (key, value) => {
    this.setState({
      validationErrorField: null,
      item: Object.assign({}, this.state.item, {
        [key]: value
      })
    })
  }

  render() {
    if (!this.props.open) {
      return null
    }
    
    return (
      <Dialog open={this.props.open}
        onRequestClose={this.props.onCloseRequest}
        actions={
          <Actions
            onCancelClicked={this.props.onCloseRequest}
            onSaveClicked={this.handleSaveClicked} />
        }
        title={<Header title={this.props.title} onCloseRequested={this.props.onCloseRequest} />}
        bodyStyle={styles.dialogBody}
        contentStyle={styles.dialogContent}
        actionsContainerStyle={{ padding: 0 }}>
        <div>
          { this.props.fields.map(field =>
            <FieldInput
              key={field.key}
              field={field}
              value={this.state.item[field.key] || ''}
              validationErrorField={this.state.validationErrorField}
              onValueChanged={this.handleValueChanged}/>)
          }
        </div>
      </Dialog>
    )
  }

}

const styles = {
  inputContainer: {
    display: 'flex',
    flexDirection: 'column',
    margin: 16
  },
  fieldDisplay: {
    color: '#4a4a4a',
    fontSize: 14,
    marginBottom: 4
  },
  subheaderDisplay: {
    color: '#4a4a4a',
    fontSize: 14,
    marginBottom: 4,
    fontWeight: 500
  },
  validationError: {
    color: '#f00',
    fontSize: 12,
    marginTop: 4
  },
  fieldInput: textAlign => ({
    borderRadius: 4,
    border: 'solid 1px #e6e8ed',
    height: 32,
    paddingLeft: 8,
    paddingRight: 8,
    fontSize: 14,
    textAlign: textAlign || 'left',
    outlineWidth: 2,
    color: '#4a4a4a'
  }),
  dialogContent: {
    borderRadius: 4,
    // This is a hack as there is a bug in Dialog's definition to properly
    // apply the border radius.
    overflow: 'auto',
    width: 360
  },
  dialogBody: {
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
    borderRadius: 4
  },
  actions: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    height: 48,
    paddingRight: 16,
    backgroundColor: '#fafafa'
  },
  header: {
    display: 'flex',
    displayDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 48,
    backgroundColor: '#fafafa'
  },
  heading: {
    fontSize: 16,
    marginLeft: 16,
    color: '#212121'
  }
}



// WEBPACK FOOTER //
// ./src/customer/common/CustomerDialog.js